var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AddPostPage"}},[_c('navigation'),_vm._v(" "),_c('centered-card',{attrs:{"headline":"Post a Video"}},[_c('post-form'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('favlet')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f716d36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/posts/AddPostPage.vue
// module id = QR1H
// module chunks = 0